import { createGlobalStyle } from "styled-components";
import themeGet from "@styled-system/theme-get";

const GlobalStyle = createGlobalStyle`
    html {
      scroll-behavior: smooth;
    }
    
    html, body {
      padding: 0;
      margin: 0;
      line-height: 1.5;
      font-family: 'Work Sans', sans-serif;
      box-sizing: border-box;
      color: ${themeGet("colors.headlines")};
    }
    
    *, *:before, *:after {
      box-sizing: inherit;
    }
    
    ul, ol {
    	margin: 0;
    	padding: 0;
    }
    
    ul li {
      margin: 0;
      padding: 0;
    }
    
    p { 
    	margin: 0;
    }
    
    a {
      cursor: pointer;
      text-decoration: none;
    }
    
    strong, b {
      font-weight: 600 !important;
    }
    
    .wrapper-tools-carousel .swiper-container .swiper-wrapper {
      width: calc(100vw - 20px);
    }
    
    .wrapper-stories-carousel {
      .swiper-container {
  
        @media screen and (min-width: 1260px) {
          width: 1240px !important;
        }
  
        @media screen and (min-width: 1340px) {
          width: 1260px !important;
        }
      
        .swiper-slide:not(.swiper-slide-active){
          opacity: 0 !important;
        }
      }
    
      .swiper-button-next, .swiper-button-prev, .swiper-pagination {
        top: auto;
        bottom: 32px;
        left: auto;
      
        @media only screen and (max-width: 991.98px) {
          bottom: 16px;
        }
        
        height: 48px;
      }
    
      .swiper-button-next, .swiper-button-prev {
        
        width: 48px;
        
        border: 1px solid #CBD0D2;
        border-radius: 50%;
        
        background-color: transparent;
        transition: all 150ms ease-in-out;
        
        &::after {
          font-size: 19px;
          width: 5px;
          
          content: none
        }
        
        &:hover, &:focus {
          background-color: #CBD0D2;
        }
        
        &:active {
          background-color: transparent;
        }
      }
      
      .swiper-button-next {
        right: 47px;
        
        @media only screen and (max-width: 1260px) {
          right: 64px;
        }
        
        @media only screen and (max-width: 991.98px) {
          right: 31px;
        }
        
        @media only screen and (max-width: 767.98px) {
          right: 15px;
        }
        
        @media screen and (max-width: 991.98px) and (min-width: 700px) {
          right: calc((100vw - 62px - 600px) / 2 + 32px);
        }
        
        background: url("data:image/svg+xml,%3Csvg width='8' height='21' viewBox='0 0 8 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.21777 1L6.70765 10.5L1.21777 20' stroke='%23006470' stroke-width='2' stroke-miterlimit='10'/%3E%3C/svg%3E%0A") no-repeat right 50% center;
      }
      
      .swiper-button-prev {
        right: 103px;
        
        @media only screen and (max-width: 1260px) {
          right: 120px;
        }
        
        @media only screen and (max-width: 991.98px) {
          right: 87px;
        }
        
        @media only screen and (max-width: 767.98px) {
          right: 71px;
        }
        
        @media screen and (max-width: 991.98px) and (min-width: 700px) {
          right: calc((100vw - 62px - 600px) / 2 + 88px);
        }
        
        background: url("data:image/svg+xml,%3Csvg width='8' height='21' viewBox='0 0 8 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.78223 1L1.29235 10.5L6.78223 20' stroke='%23006470' stroke-width='2' stroke-miterlimit='10'/%3E%3C/svg%3E%0A") no-repeat center;
      }
    
      .swiper-pagination {
        right: 164px;
          
        width: 36px;
          
        display: flex;
        align-items: center;
        justify-content: space-between;
          
        color: #9AAAB280;
        
        @media only screen and (max-width: 1260px) {
          right: 181px;
        }
        
        @media only screen and (max-width: 991.98px) {
          right: 148px;
        }
        
        @media only screen and (max-width: 767.98px) {
          right: 132px;
        }
        
        @media screen and (max-width: 991.98px) and (min-width: 700px) {
          right: calc((100vw - 62px - 600px) / 2 + 151px);
        }
          
        span {
          color: #9AAAB2;
        }
      }
      
      // Editing the properties just for desktop
      &--reversed {
        
        .swiper-button-next {
          right: 601px;
          
          @media only screen and (max-width: 1260px) {
            right: calc(500px + 7%);
          }
          
          // These (mobile & tablet) are the same as w/o reversed
          @media only screen and (max-width: 991.98px) {
            right: 31px;
          }
          
          @media only screen and (max-width: 767.98px) {
            right: 15px;
          }
          
          @media screen and (max-width: 991.98px) and (min-width: 700px) {
            right: calc((100vw - 62px - 600px) / 2 + 32px);
          }
        }
        
        .swiper-button-prev {
          right: 657px;
          
          @media only screen and (max-width: 1260px) {
            right: calc(556px + 7%);
          }
          
          // These (mobile & tablet) are the same as w/o reversed
          @media only screen and (max-width: 991.98px) {
            right: 87px;
          }
          
          @media only screen and (max-width: 767.98px) {
            right: 71px;
          }
          
          @media screen and (max-width: 991.98px) and (min-width: 700px) {
            right: calc((100vw - 62px - 600px) / 2 + 88px);
          }
        }
      
        .swiper-pagination {
          right: 718px;
          
          @media only screen and (max-width: 1260px) {
            right: calc(617px + 7%);
          }
          
          // These (mobile & tablet) are the same as w/o reversed
          @media only screen and (max-width: 991.98px) {
            right: 148px;
          }
          
          @media only screen and (max-width: 767.98px) {
            right: 132px;
          }
          
          @media screen and (max-width: 991.98px) and (min-width: 700px) {
            right: calc((100vw - 62px - 600px) / 2 + 151px);
          }
        }
      }
    }
`;

export default GlobalStyle;
